import api from "../../services/api";

const leaveService = {
  // Leave request workflow
  createLeaveRequest: async (payload) => {
    const response = await api.post("/api/leave/request", payload);
    return response.data;
  },

  getLeaveRequests: async (params = {}) => {
    const response = await api.get("/api/leave/requests", { params });
    return response.data;
  },

  getLeaveRequest: async (id) => {
    const response = await api.get(`/api/leave/request/${id}`);
    return response.data;
  },

  approveLeaveRequest: async (id) => {
    const response = await api.post(`/api/leave/approve/${id}`);
    return response.data;
  },

  rejectLeaveRequest: async (id, reason) => {
    const response = await api.post(`/api/leave/reject/${id}`, { reason });
    return response.data;
  },

  cancelLeaveRequest: async (id) => {
    const response = await api.post(`/api/leave/cancel/${id}`);
    return response.data;
  },

  // Leave balance
  getLeaveBalance: async (params) => {
    const response = await api.get("/api/leave/balance", { params });
    return response.data;
  },

  initializeBalance: async (payload) => {
    const response = await api.post("/api/leave/balance/init", payload);
    return response.data;
  },

  // Leave policies
  getPolicies: async (params = {}) => {
    const response = await api.get("/api/leave/policies", { params });
    return response.data;
  },

  createPolicy: async (payload) => {
    const response = await api.post("/api/leave/policy", payload);
    return response.data;
  },

  // Holiday calendars
  listHolidayCalendars: async (params = {}) => {
    const response = await api.get("/api/holiday", { params });
    return response.data;
  },

  createHolidayCalendar: async (payload) => {
    const response = await api.post("/api/holiday", payload);
    return response.data;
  },

  addHolidayToCalendar: async (calendarId, payload) => {
    const response = await api.post(
      `/api/holiday/${calendarId}/holiday`,
      payload,
    );
    return response.data;
  },

  removeHolidayFromCalendar: async (calendarId, holidayId) => {
    const response = await api.delete(
      `/api/holiday/${calendarId}/holiday/${holidayId}`,
    );
    return response.data;
  },
};

export default leaveService;
